import type { HeadlineData } from './headline.types';
import { Headline } from './Headline.ui';

interface HeadlineRendererProps {
  block: HeadlineData;
}

export function HeadlineRenderer({ block }: HeadlineRendererProps) {
  const { shortSummary, title, backgroundColor, headingAlignment, isActive } = block;
  if (!isActive) return null;

  return (
    <Headline
      shortSummary={shortSummary}
      title={title}
      backgroundColor={backgroundColor}
      headingAlignment={headingAlignment}
    />
  );
}
